// extracted by mini-css-extract-plugin
export default {"overlay":"nA-z","bodyOpen":"oA-z","content":"pA-z","header":"qA-z","close":"rA-z","closeNoHeading":"sA-z"};